<template>
  <div class="app-root">
    <router-view />
    <ErrorDialog />
  </div>
</template>

<script>
import ErrorDialog from '@/containers/ErrorDialog.vue'

export default {
  name: 'App',

  components: {
    ErrorDialog
  },

  created() {
    this.getFavoriteCourses()
  },

  methods: {
    // This function forces fetching favouriteCourse list from localStorage to update favoriteCourses vuex state when the page is refreshed

    getFavoriteCourses() {
      const favoriteCourses = localStorage.getItem('favoriteCourses') || '[]'
      this.$store.commit('SET_FAVORITE_COURSES', JSON.parse(favoriteCourses))
    }
  }

}
</script>

<style lang="scss">
// Import Main styles for this application
@import "./scss/styles.scss";
</style>
